import { render, staticRenderFns } from "./AlcoholWarningDialog.vue?vue&type=template&id=469d96e6"
import script from "./AlcoholWarningDialog.vue?vue&type=script&lang=ts"
export * from "./AlcoholWarningDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports